
import { defineComponent, ref, reactive, toRefs, onMounted, watch, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      pagination1: {},
      data: [],
      columns: [],
      spinning: true,
      pagination: {},
      total: 0,
      years: []
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: any) => `共${pageData.total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    pageData.columns = computed(() => {
      const tableInfo1: any = []
      const tableInfo2: any = []
      pageData.years.forEach((item: any, i: number) => {
        tableInfo1.push({
          title: item + '年预测',
          dataIndex: 'year' + (i + 1) + 'EPS',
          key: 'year' + (i + 1) + 'EPS',
          width: '110px',
          slots: { customRender: 'RLnocolorincrease' }
        })
        tableInfo2.push({
          title: item + '年预测',
          dataIndex: 'year' + (i + 1) + 'Profit',
          key: 'year' + (i + 1) + 'Profit',
          width: '110px',
          slots: { customRender: 'RLpeopleCount' }
        })
      })
      return [
        {
          title: '报告日期',
          dataIndex: 'time',
          key: 'time',
          width: '100px'
        },
        {
          title: '机构名称',
          dataIndex: 'AgentName',
          key: 'AgentName',
          width: '100px',
          ellipsis: true,
          slots: { customRender: 'ellipsis' }
        },
        {
          title: '研究员',
          dataIndex: 'ReportName',
          key: 'ReportName',
          width: '100px',
          ellipsis: true,
          slots: { customRender: 'ellipsis' }
        },
        {
          title: '预测年报每股收益（元）',
          children: tableInfo1
        },
        {
          title: '预测年报净利润（元）',
          children: tableInfo2
        }
      ]
    })
    const route = useRoute()
    function getData(PageID: number, PageSize: number) {
      const data: any = {}
      data.data = {
        // Exch: route.query.market,
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code,
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getprofitforecastDetail(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify(res.Data))
        if ((data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'ForecastDetail' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
            if ((item.PerYearForecastData || []).length) {
              item.year1EPS = ((item.PerYearForecastData || [])[0] || {}).EPS || null
              item.year2EPS = ((item.PerYearForecastData || [])[1] || {}).EPS || null
              item.year3EPS = ((item.PerYearForecastData || [])[2] || {}).EPS || null
              item.heightyear1EPS = ((item.PerYearForecastData || [])[0] || {}).EPSTag
              item.heightyear2EPS = ((item.PerYearForecastData || [])[1] || {}).EPSTag
              item.heightyear3EPS = ((item.PerYearForecastData || [])[2] || {}).EPSTag
              item.year1Profit = ((item.PerYearForecastData || [])[0] || {}).Profit || null
              item.year2Profit = ((item.PerYearForecastData || [])[1] || {}).Profit || null
              item.year3Profit = ((item.PerYearForecastData || [])[2] || {}).Profit || null
              item.heightyear1Profit = ((item.PerYearForecastData || [])[0] || {}).ProfitTag
              item.heightyear2Profit = ((item.PerYearForecastData || [])[1] || {}).ProfitTag
              item.heightyear3Profit = ((item.PerYearForecastData || [])[2] || {}).ProfitTag
            }
          })
        }
        pageData.total = data.Total
        pageData.data = data.Detail
      })
    }
    getData(1, 10)
    function changesize(PageID: any, PageSize: any) {
      getData(PageID, PageSize)
      const dom: any = document.querySelector('.wrapper')
      const offsettop: any = document.getElementById('ycmx')?.offsetTop
      dom.scrollTop = offsettop
    }
    watch(
      () => ((props || {}).pageSourceData || {}).ForecastDetail,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data.Detail || []).length) {
          pageData.years = data.Detail[0].PerYearForecastData.map((item: any) => item.Year)
        }
        pageData.total = data.Total
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData)
    }
  }
})
